import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var FinalizedItem = function (props) {
    var i18n = props.i18n, finalizedCase = props.finalizedCase;
    var author = finalizedCase.author;
    var description = getPropsByKeyPath(i18n, 'modules.timeline.finalizedCase.textAction').replace('$username ', '');
    var authorLabel = (author === null || author === void 0 ? void 0 : author.login) || getPropsByKeyPath(i18n, 'modules.timeline.defaultUser');
    return (_jsx(_Fragment, { children: _jsxs("p", { children: [_jsx("b", { children: authorLabel }), " ", description] }) }));
};
